import React, {useEffect} from 'react';
import {useSelector} from "react-redux";

export const hasScope = (session, scopes, serviceId) => {
    return (
        serviceId ?
            scopes.constructor === Array ?
                session?.user?.scopes.find(scope => scopes.includes(scope)) && (session?.user?.scopes.find('SERVICE_SGP_ADMIN') || session?.services?.find(service => service.id === serviceId)) && true
                :
                session?.user?.scopes.find(scope => scopes === scope) && (session?.user?.scopes.find('SERVICE_SGP_ADMIN') || session?.services?.find(service => service.id === serviceId)) && true
            :
            scopes.constructor === Array ?
                session?.user?.scopes.find(scope => scopes.includes(scope)) && true
                :
                session?.user?.scopes.find(scope => scopes === scope) && true
    ) ?? false
}

export const isEventManager = (session,eventId) => hasScope(session,'SERVICE_SGP_ADMIN') ||
    (
        session?.services &&
        session?.services.find(evt => evt.id === eventId) &&
        hasScope(session,['SERVICE_SGP_MANAGER','SERVICE_SGP_ADMIN','SERVICE_SGP_SCORER'])
    )

export const isSgpAdmin = (session) => hasScope(session,'SERVICE_SGP_ADMIN')

export const useUserRole = () => {
    const session = useSelector( state => state.session)

    const [adminAccess, setAdminAccess] = React.useState(isSgpAdmin(session))
    const [eventManagerAccess, setEventManagerAccess] = React.useState(session.event ? isEventManager(session,session.event?.id) : undefined)

    useEffect(() => {
        setAdminAccess(isSgpAdmin(session))
        setEventManagerAccess(session.event ? isEventManager(session,session.event?.id) : undefined)
    }, [session.services,session.event]);

    return {
        isAdmin: adminAccess,
        isManager: eventManagerAccess,
    }
}